<template>
  <div class="spl-report-list-header">
    <form-button @onClick="handleCreateReport">
      Create Report
    </form-button>
  </div>
</template>

<script>
export default {
  methods: {
    handleCreateReport () {
      this.$router.push('/report-create')
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .spl-report-list-header {
    position: relative;
    padding: 0 $mainPadding;
    margin: 15px 0;
  }

</style>
